import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["reason", "other", "otherInput"];

  connect() {
    this.toggleOther();
  }

  toggleOther() {
    if (!this.hasReasonTarget) return;
    const needsDetails = this.reasonTarget.value === "other";
    this.otherTarget.classList.toggle("hidden", !needsDetails);
    this.otherInputTarget.required = needsDetails;
    if (!needsDetails) this.otherInputTarget.value = "";
  }
}
